import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import useId from '../../utils/use-id.js';
import { Wrapper, Button, Circle, Label } from './switch.style.js';

const Switch = props => {
    const { checked, className = '', disabled = false, id, label, margin, onChange, width = '200px' } = props, rest = __rest(props, ["checked", "className", "disabled", "id", "label", "margin", "onChange", "width"]);
    const elementId = useId('select', id);
    const handleOnChange = (e) => {
        e.preventDefault();
        if (!disabled)
            onChange(e);
    };
    return (jsxs(Wrapper, Object.assign({ className: className, width: width, margin: margin }, { children: [jsx(Button, Object.assign({ id: elementId, "aria-pressed": checked, checked: checked, disabled: disabled, onClick: handleOnChange }, rest, { children: jsx(Circle, { checked: checked, disabled: disabled }, void 0) }), void 0), label && (jsx(Label, Object.assign({ margin: { left: '16px', top: '4px' }, htmlFor: elementId, disabled: disabled }, { children: label }), void 0))] }), void 0));
};

export { Switch };
